import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../../redux/dashboardSlice.js';

/**
 * Open/close state for FormulaFieldDialog.
 * `editedField` is null when creating a new formula field.
 * Also flags the dashboard modal state, so the settings sidebar stays open while the dialog is shown.
 */
export const useFormulaDialog = () => {
  const dispatch = useDispatch();
  const [dialog, setDialog] = useState({ open: false, editedField: null });

  const openDialog = useCallback((editedField = null) => {
    dispatch(openModal());
    setDialog({ open: true, editedField });
  }, [dispatch]);

  const closeDialog = useCallback(() => {
    dispatch(closeModal());
    setDialog({ open: false, editedField: null });
  }, [dispatch]);

  return { ...dialog, openDialog, closeDialog };
};
